import React from "react";
import Layout from "src/components/layout/website/Layout";
import { PAGE_SEO } from "src/constants/seo";

const FAQsPage: React.FC = () => {
  const faqs = [
    {
      q: "What is Invyntra?",
      a: "Invyntra is a cloud-based inventory management platform for small and medium businesses, built to track stock, purchases, and sales in one place.",
    },
    {
      q: "Is there a free trial?",
      a: "New accounts start on a free 15-day Trial plan with full access to core features — no credit card required. We're in early access, so reach out via Contact and we'll get you set up.",
    },
    {
      q: "Can I manage multiple branches?",
      a: "Yes. Invyntra's multi-tenant architecture supports managing multiple branches or business units under one account.",
    },
    {
      q: "Can I export reports?",
      a: "Yes, you can export reports as PDF from the dashboard.",
    },
    {
      q: "Can I collect payments from my customers?",
      a: "Yes. Connect your own Razorpay account in Settings → Payments, then collect full or partial payments on any sale order — through Razorpay's payment window, a payment link shared on WhatsApp or email, or a QR code. Money goes straight into your Razorpay account; Invyntra never holds it. Cash payments can be recorded too.",
    },
    {
      q: "What happens to payments when I cancel an order?",
      a: "Online payments are refunded automatically through your Razorpay account to the customer's original payment method, usually within 5–7 working days. Cash and other offline payments have to be returned by you — mark them as returned in Invyntra, and until then they're shown as refund due.",
    },
  ];

  return (
    <Layout
      meta={PAGE_SEO.faqs}
    >
      <div className="min-h-screen bg-white py-20 px-6 max-w-5xl mx-auto">
        <h1 className="text-4xl font-bold text-indigo-600 text-center mb-12">
          Frequently Asked Questions
        </h1>
        <div className="space-y-8">
          {faqs.map((item, i) => (
            <div key={i} className="border-b pb-4">
              <h3 className="font-semibold text-lg text-gray-800 mb-2">
                {item.q}
              </h3>
              <p className="text-gray-600">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default FAQsPage;
